module.exports = __webpack_public_path__ + "img/program.ccda2b7a.svg";